var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hotel-block-header" }, [
    _vm.agency
      ? _c(
          "a",
          {
            staticClass: "hotel-block-header__back",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                _vm.$emit("goback")
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 223 395.65"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M223,370.5a25,25,0,0,0-7.37-17.79L73.49,210.57,60.76,197.84l12.73-12.73L215.63,43A25.16,25.16,0,1,0,180,7.38L7.37,180a25.16,25.16,0,0,0,0,35.58L180,388.29a25.17,25.17,0,0,0,43-17.79Z"
                  }
                })
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "hotel-block-header__info" },
      [
        _vm.orderNumber
          ? _c(
              "span",
              { staticClass: "hotel-block-header__info__booking-number" },
              [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.booking_number)
                  }
                }),
                _vm._v(" " + _vm._s(_vm.orderNumber))
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "title-transition" } }, [
          _vm.hotel.title
            ? _c("h3", {
                domProps: { textContent: _vm._s(_vm.hotel.title) },
                on: {
                  click: function($event) {
                    _vm.$emit("titleclick")
                  }
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "location-transition" } }, [
          _vm.hotel.location && !_vm.agency
            ? _c("h4", {
                domProps: { textContent: _vm._s(_vm.hotel.location) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.hasStars
          ? _c(
              "div",
              { staticClass: "hotel-stars" },
              _vm._l(_vm.stars, function(star, starKey) {
                return _c(
                  "svg",
                  {
                    key: starKey,
                    staticClass: "hotel-stars__icon",
                    class: { "hotel-stars__icon--filled": star },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 31.99 30.39"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M31.94,11.54a1,1,0,0,0-1-.7H20.26L16.94.69a1,1,0,0,0-1.9,0L11.73,10.84H1a1,1,0,0,0-.95.7,1,1,0,0,0,.36,1.11l8.68,6.28L5.78,29.08A1,1,0,0,0,7.31,30.2L16,23.92l8.68,6.28a1,1,0,0,0,.59.19,1,1,0,0,0,.95-1.31L22.9,18.93l8.67-6.28a1,1,0,0,0,.37-1.11Z"
                      }
                    })
                  ]
                )
              })
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "hotel-block-header__actions" }, [
      _vm.hasRating
        ? _c(
            "div",
            {
              staticClass: "hotel-review-btn-wrapper",
              class: { "ratings-shown": _vm.showRating },
              on: {
                click: _vm.showHoverRating,
                mouseover: _vm.showHoverRating,
                mouseout: _vm.hideHoverRating
              }
            },
            [
              _c("button", { staticClass: "hotel-review-btn" }, [
                _vm.rating.recommendation >= 85
                  ? _c(
                      "svg",
                      {
                        class: {
                          "icon-overhappy": _vm.rating.recommendation >= 85
                        },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 358.4 358.4"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,0C80.39,0,0,80.39,0,179.2S80.39,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.6,153.6,0,0,1,179.2,25.6"
                          }
                        }),
                        _c("circle", {
                          attrs: { cx: "240.64", cy: "148.47", r: "25.6" }
                        }),
                        _c("circle", {
                          attrs: { cx: "117.77", cy: "148.47", r: "25.6" }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,291A132.66,132.66,0,0,1,64.74,224.88,12.8,12.8,0,1,1,86.9,212.06a106.57,106.57,0,0,0,184.61,0,12.8,12.8,0,0,1,22.16,12.82A132.69,132.69,0,0,1,179.2,291Z"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rating.recommendation >= 60 &&
                _vm.rating.recommendation < 85
                  ? _c(
                      "svg",
                      {
                        class: {
                          "icon-happy":
                            _vm.rating.recommendation >= 60 &&
                            _vm.rating.recommendation < 85
                        },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 358.4 358.4"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,0C80.4,0,0,80.4,0,179.2S80.4,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.64,153.64,0,0,1,179.2,25.6"
                          }
                        }),
                        _c("circle", {
                          attrs: { cx: "240.6", cy: "148.5", r: "25.6" }
                        }),
                        _c("circle", {
                          attrs: { cx: "117.8", cy: "148.5", r: "25.6" }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,280.7a131.53,131.53,0,0,1-87.4-33.1,12.82,12.82,0,1,1,17-19.2,106.73,106.73,0,0,0,141,0,12.82,12.82,0,0,1,17,19.2A132.42,132.42,0,0,1,179.2,280.7Z"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rating.recommendation >= 35 &&
                _vm.rating.recommendation < 60
                  ? _c(
                      "svg",
                      {
                        class: {
                          "icon-neutral":
                            _vm.rating.recommendation >= 35 &&
                            _vm.rating.recommendation < 60
                        },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 358.4 358.4"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,0C80.39,0,0,80.39,0,179.2S80.39,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.6,153.6,0,0,1,179.2,25.6"
                          }
                        }),
                        _c("circle", {
                          attrs: { cx: "240.64", cy: "148.47", r: "25.6" }
                        }),
                        _c("circle", {
                          attrs: { cx: "117.77", cy: "148.47", r: "25.6" }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M258.12,250.87H100.28a12.8,12.8,0,0,1,0-25.6H258.12a12.8,12.8,0,1,1,0,25.6Z"
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rating.recommendation >= 0 && _vm.rating.recommendation < 35
                  ? _c(
                      "svg",
                      {
                        class: {
                          "icon-sad":
                            _vm.rating.recommendation >= 0 &&
                            _vm.rating.recommendation < 35
                        },
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 358.4 358.4"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M179.2,0C80.4,0,0,80.4,0,179.2S80.4,358.4,179.2,358.4,358.4,278,358.4,179.2,278,0,179.2,0Zm0,25.6A153.6,153.6,0,1,1,25.6,179.2,153.64,153.64,0,0,1,179.2,25.6"
                          }
                        }),
                        _c("circle", {
                          attrs: { cx: "240.6", cy: "148.5", r: "25.6" }
                        }),
                        _c("circle", {
                          attrs: { cx: "117.8", cy: "148.5", r: "25.6" }
                        }),
                        _c("path", {
                          attrs: {
                            d:
                              "M258.1,265.4a13.24,13.24,0,0,1-8.5-3.2,106.73,106.73,0,0,0-141,0,12.82,12.82,0,1,1-17-19.2,131.94,131.94,0,0,1,174.8,0,12.82,12.82,0,0,1,1.1,18.1A12.12,12.12,0,0,1,258.1,265.4Z"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "show-transition" } }, [
                _vm.showRatingHelp
                  ? _c(
                      "div",
                      { staticClass: "user-ratings user-ratings--help" },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.translations.rating_help)
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("user-ratings", {
                attrs: {
                  rating: _vm.hotel.rating,
                  open: _vm.showRating && _vm.hasRating
                },
                on: {
                  close: function($event) {
                    _vm.showRating = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFavorite
        ? _c(
            "button",
            {
              staticClass: "hotel-like-btn",
              class: { "hotel-like-btn--saved": _vm.favorite },
              on: { click: _vm.toogleFavorite }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 32.01 28.01"
                  }
                },
                [
                  _c("path", {
                    staticClass: "hotel-like-btn__fill",
                    attrs: {
                      d:
                        "M16,27c-.58,0-1.53-1-2.29-1.71l-10-10A8.2,8.2,0,1,1,15.26,3.69L16,4.5l.74-.81A8.19,8.19,0,1,1,28.32,15.26l-10,10C17.54,26.06,16.59,27,16,27Z"
                    }
                  }),
                  _c("path", {
                    staticClass: "hotel-like-btn__stroke",
                    attrs: {
                      d:
                        "M22.81,2a7.19,7.19,0,0,1,4.84,12.52l0,0,0,0-10,10A9.42,9.42,0,0,1,16,26a9.81,9.81,0,0,1-1.58-1.39l-10-10,0,0,0,0A7.19,7.19,0,1,1,14.52,4.36L16,6l1.48-1.63A7.23,7.23,0,0,1,22.81,2m0-2A9.16,9.16,0,0,0,16,3,9.19,9.19,0,1,0,3,16L13,26c1,1,2,2,3,2s2-1,3-2L29,16A9.19,9.19,0,0,0,22.81,0Z"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f2a6558", { render: render, staticRenderFns: staticRenderFns })
  }
}